export default function getOffset(page, rows_per_page) {
  return page === 1 ? 1 : (page - 1) * rows_per_page + 1
}
